import {
  Column,
  CreateDateColumn,
  Entity,
  Index,
  JoinColumn,
  ManyToOne,
  PrimaryColumn,
  Unique,
  UpdateDateColumn,
} from 'typeorm';
import type { Relation } from 'typeorm';
import { UserEntity } from './user.entity';
import { AccountProvider } from '../types/account-provider';

/**
 * Account entity for storing linked social provider accounts.
 * Each account links a user to a social provider (Google, Facebook).
 */
@Entity({ name: 'accounts' })
@Index(['userId'])
@Unique(['provider', 'providerAccountId'])
export class AccountEntity {
  // DB generates the value (uuid_generate_v4() from migration 1700000000000).
  // Using @PrimaryColumn instead of @PrimaryGeneratedColumn('uuid') prevents
  // TypeORM's PostgresDriver from auto-issuing CREATE EXTENSION "uuid-ossp" on
  // every connect — which fails for non-superuser Cloud SQL IAM users.
  @PrimaryColumn({ type: 'uuid', default: () => 'uuid_generate_v4()' })
  id!: string;

  @Column({ type: 'varchar' })
  userId!: string;

  @Column({ type: 'varchar' })
  provider!: AccountProvider;

  @Column({ type: 'varchar', length: 255 })
  providerAccountId!: string;

  @ManyToOne(() => UserEntity, (user) => user.accounts, {
    createForeignKeyConstraints: true,
    onDelete: 'CASCADE',
  })
  @JoinColumn({ name: 'user_id' })
  user!: Relation<UserEntity>;

  @CreateDateColumn({ type: 'timestamptz' })
  createdAt!: Date;

  @UpdateDateColumn({ type: 'timestamptz' })
  updatedAt!: Date;
}
